package team.platforma.dictionary_data.database_factory

import app.cash.sqldelight.async.coroutines.awaitCreate
import app.cash.sqldelight.driver.worker.WebWorkerDriver
import org.w3c.dom.Worker
import team.platforma.dictionarydata.database.DictionaryDatabase

actual class DictionaryDBFactory actual constructor() {
    actual suspend fun web(): DictionaryDatabase? {
        val driver = WebWorkerDriver(
            Worker(
                js("""new URL("@cashapp/sqldelight-sqljs-worker/sqljs.worker.js", import.meta.url)""")
            )
        )
        DictionaryDatabase.Schema.awaitCreate(driver)
        return DictionaryDatabase(driver)
    }
}